/*
Copyright 2025 TekNix Corporation

This software is proprietary and confidential to TekNix Corporation.
All rights reserved. No part of this software may be reproduced, distributed,
or transmitted in any form or by any means, including photocopying, recording,
or other electronic or mechanical methods, without the prior written permission
of TekNix Corporation, except in the case of brief quotations embodied in
critical reviews and certain other noncommercial uses permitted by copyright law.

For permission requests, write to TekNix Corporation at the address below:
TekNix Corporation
Legal Department

UNAUTHORIZED REPRODUCTION OR DISTRIBUTION IS STRICTLY PROHIBITED.
*/

import type { XHubChatEvent } from '../models/event/event';

export enum RelationsEvent {
  Add = 'Relations.add',
  Remove = 'Relations.remove',
  Redaction = 'Relations.redaction',
}

export type EventHandlerMap = {
  [RelationsEvent.Add]: (event: XHubChatEvent) => void;
  [RelationsEvent.Remove]: (event: XHubChatEvent) => void;
  [RelationsEvent.Redaction]: (event: XHubChatEvent) => void;
};
